import type { AppState } from './batch';
import { requireEl } from './dom';

export const state: AppState = {
  allCats: [],
  filter: 'all',
  idx: 0,
  nextId: 1,
  loading: false,
  ended: false,
  offset: 0,
};

/** Incremented on filter reset — stale fetch responses are ignored. */
export let galleryEpoch = 0;

export function bumpGalleryEpoch(): number {
  galleryEpoch += 1;
  return galleryEpoch;
}

export const els = {
  grid: requireEl<HTMLElement>('grid'),
  loader: requireEl<HTMLElement>('loader'),
  sentinel: requireEl<HTMLElement>('sentinel'),
  count: requireEl<HTMLElement>('count'),
};
